const PERIOD_TYPE_MONTH = 'month';
const PERIOD_TYPE_DATE = 'date';

export const PERIOD_TYPES = {
    PERIOD_TYPE_MONTH,
    PERIOD_TYPE_DATE
};
export const PERIOD_TYPES_ARR = Object.keys(PERIOD_TYPES).map(key => PERIOD_TYPES[key]);



// WEBPACK FOOTER //
// ./src/config/constants/period.js